import { Component } from '@theme/component';

/**
 * Scroll control for the category row.
 *
 * The row is a native scroll-snap track rather than a JS carousel, so these buttons only
 * nudge it by one card. That keeps keyboard, touch and trackpad behaviour native and means
 * the row still works if this script never loads.
 *
 * @extends {Component}
 */
class CivitalCategoryLinks extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.addEventListener('click', this.#onClick);
    this.#track?.addEventListener('scroll', this.#sync, { passive: true });
    this.#sync();
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.removeEventListener('click', this.#onClick);
    this.#track?.removeEventListener('scroll', this.#sync);
  }

  /** @returns {HTMLElement | null} */
  get #track() {
    return this.querySelector('.civital-category-links__track');
  }

  /** @param {Event} event */
  #onClick = (event) => {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const button = target.closest('[data-scroll]');
    const track = this.#track;

    if (!(button instanceof HTMLElement) || !track) return;

    const item = track.querySelector('.civital-category-links__item');
    const step = item ? item.getBoundingClientRect().width + 16 : track.clientWidth / 2;

    track.scrollBy({ left: step * Number(button.dataset.scroll), behavior: 'smooth' });
  };

  /** Disable an arrow once the track cannot move further that way. */
  #sync = () => {
    const track = this.#track;

    if (!track) return;

    const max = track.scrollWidth - track.clientWidth;

    for (const button of this.querySelectorAll('[data-scroll]')) {
      if (!(button instanceof HTMLButtonElement)) continue;

      const forward = Number(button.dataset.scroll) > 0;
      button.disabled = forward ? track.scrollLeft >= max - 1 : track.scrollLeft <= 1;
    }
  };
}

if (!customElements.get('civital-category-links')) {
  customElements.define('civital-category-links', CivitalCategoryLinks);
}
